import { useMutation, useQueryClient } from "@tanstack/react-query";

import { errorHandler } from "#app/monitoring/errorHandler";
import { showErrorToast, showSuccessToast } from "#app/notifications";
import { quoteRequestLinesQuery } from "#modules/quoteRequestLines/quoteRequestLinesQuery";
import { QuoteRequestDto } from "#modules/quoteRequests/infra/fetchQuoteRequest.api";
import { quoteRequestQuery } from "#modules/quoteRequests/infra/quoteRequest.query";
import { updateArchiveQuoteRequest } from "#modules/quoteRequests/infra/updateArchiveQuoteRequest.api";

export const useUpdateArchiveQuoteRequest = (quoteRequest: QuoteRequestDto | null | undefined) => {
  const queryClient = useQueryClient();

  const { mutate, ...rest } = useMutation({
    mutationFn: updateArchiveQuoteRequest,
    onSuccess: () => {
      void queryClient.invalidateQueries(quoteRequestQuery(quoteRequest?.id));

      void queryClient.invalidateQueries(quoteRequestLinesQuery());

      const title = quoteRequest?.isArchived
        ? "Cette demande est maintenant désarchivée"
        : "Cette demande est maintenant archivée";

      showSuccessToast({ title });
    },
    onError: (err) => {
      showErrorToast({ title: "Une erreur est survenue" });
      errorHandler(err);
    },
  });

  return { updateArchiveQuoteRequest: mutate, ...rest };
};
